import { Box } from '@palmetto/palmetto-components';

import { SabalInternalEvents } from 'types';

import EventBy from './EventBy';

// Reads as "<actor> <phrase>", matching the other single-line activity rows (e.g. QuoteCreated).
const CHANGE_ORDER_EVENT_PHRASE: Partial<Record<SabalInternalEvents, string>> = {
  [SabalInternalEvents.sabalChangeOrderCreated]: 'created a change order',
  [SabalInternalEvents.sabalChangeOrderEmailed]: 'emailed the change order',
  [SabalInternalEvents.sabalChangeOrderSmsed]: 'texted the change order',
  [SabalInternalEvents.sabalChangeOrderResendSent]: 'resent the change order',
  [SabalInternalEvents.sabalChangeOrderViewed]: 'viewed the change order',
  [SabalInternalEvents.sabalChangeOrderAccepted]: 'accepted the change order',
  [SabalInternalEvents.sabalChangeOrderDeclined]: 'declined the change order',
  [SabalInternalEvents.sabalChangeOrderExecuted]: 'executed the change order',
  [SabalInternalEvents.sabalChangeOrderCancelled]: 'cancelled the change order',
  [SabalInternalEvents.sabalChangeOrderVoided]: 'voided the change order',
  [SabalInternalEvents.sabalChangeOrderEpcNotified]: 'notified the EPC of change order acceptance',
  [SabalInternalEvents.sabalChangeOrderCustomerNotified]: 'notified the customer of change order acceptance',
};

const ChangeOrderEvent = ({ event }: { event: { eventType: SabalInternalEvents } }) => {
  const phrase = CHANGE_ORDER_EVENT_PHRASE[event.eventType] ?? 'updated a change order';

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> {phrase}
      </Box>
    </Box>
  );
};

export default ChangeOrderEvent;
